module.exports = __webpack_public_path__ + "static/img/3.1f5dbdf0.png";